import { IRequestStatus } from "./IRequestStatus"

export const RequestStatus: IRequestStatus = {
  NEW: "Новый",
  APPROVED: "Подтвержден",
  REJECTED: "Отклонен",
  USED: "С пополнением"
}
